app.controller("AddSubjectController", [
    "$scope", "$http", "$uibModalInstance", "Subject", "StaticData", "InfoModal", "GradeTemplate",
    function ($scope, $http, $uibModalInstance, Subject, StaticData, InfoModal, GradeTemplate) {
        $scope.name = "";
        $scope.nameEN = "";
        $scope.dep_id = "";
        $scope.author = "";
        $scope.level = null;
        $scope.newDependency = null;
        $scope.credits = 5;
        $scope.dependencies = [];

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = levels;
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        $scope.$watch('newDependency', function (val) {
            if (val && val._id) {
                $scope.dependencies.push(val);
                $scope.newDependency = null;
            }
        }, true);

        $scope.delete_dependency = function (id) {
            var el_index = _.findIndex($scope.dependencies, function (dep) {
                return id === dep._id;
            });

            $scope.dependencies.splice(el_index, 1);
        };

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({query: query}).then(function (data) {
                return data.docs.filter(function (subj) {
                    var el_index = _.findIndex($scope.dependencies, function (dependency) {
                        return dependency._id === subj._id;
                    });

                    return el_index === -1;
                })
            });
        };

        GradeTemplate.list().then(function (list) {
            $scope.templates = list;
        });

        $scope.create = function () {

            if (!$scope.template) {
                InfoModal.show({message: "გთხოვთ მიუთითოთ შაბლონი", title: "შეცდომა"});
                return;
            }

            if (!$scope.level) {
                InfoModal.show({message: "გთხოვთ მიუთითოთ საფეხური", title: "შეცდომა"});
                return;
            }

            if (!$scope.addSubjectForm.$valid) {
                InfoModal.show({message: "შეავსეთ ყველა ველი სწორად", title: "შეცდომა"});
                return;
            }

            var prerequisites_list = [];
            $scope.dependencies.forEach(function (el) {
                prerequisites_list.push(el._id);
            });
            var p_data = {
                name: $scope.name,
                nameEN: $scope.nameEN,
                author: $scope.author,
                code: $scope.code,
                credits: $scope.credits,
                level: $scope.level,
                prerequisites: prerequisites_list,
                gradeTemplate: $scope.template,
                syllabusFile: $scope.syllabusFile
            };
            Subject.create(p_data).then(function (resp) {
                $uibModalInstance.close();
            });
        };
        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.uploadSyllabus = function (files) {
            $scope.file = files[0];
            if ($scope.file) {
                $scope.fileName = $scope.file.name;
                var fd = new FormData();
                fd.append('file', $scope.file);
                $http.post('/file/syllabus/upload', fd, {
                    headers: {'Content-Type': undefined}
                }).then(function (response) {
                    //console.log(response)
                    $scope.syllabusFile = response.data.Location;
                })
            }
        };
    }
]);
